export interface GetIntegrationSettingListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetIntegrationSettingListPagingAndFilterResponseData
}

export interface GetIntegrationSettingListPagingAndFilterResponseData {
    items: GetIntegrationSettingListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetIntegrationSettingListPagingAndFilterResponseItem {
    integrationSettingId: string
    companyId: string
    integrationId: string
    text: string
    /** Son çalışma: "22.09.2026 18:40 · 3 dk 12 sn · başarılı". Zamanlanmamış entegrasyonda boş. */
    lastRunStr?: string
    /** Ne sıklıkla çalıştığı ve ne kadarlık çekim yaptığı; sunucuda koddaki zamanlama değerlerinden üretilir. */
    description?: string
    integrationName: string
    integrationKey: string
    companyName: string
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetIntegrationSettingListPagingAndFilterResponseData: GetIntegrationSettingListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}